import type {
  FilterKey,
  FilterParams,
  MultiSelectFilterKey,
} from '../../../Entities/Search/QueryParams.entity';
import { stringToArray } from '../../../Utils/Strings/StringToArray';
import { ARRAY_ONLY_FILTERS_KEY, MULTISELECT_FILTERS_KEY } from '../Filters.constants';

export const mergeSlugAndSearchParams = (slugParams: FilterParams, searchParams: FilterParams) => {
  const mergedParams: Record<string, string | string[] | undefined> = { ...slugParams };

  //slugParams take preference
  Object.keys(searchParams).forEach(key => {
    const typedKey = key as FilterKey;
    const value = searchParams[typedKey] as string | string[] | undefined;
    const isMultiSelectFltr = MULTISELECT_FILTERS_KEY.includes(typedKey as MultiSelectFilterKey);
    const isArrayOnlyFltr = ARRAY_ONLY_FILTERS_KEY.includes(typedKey as MultiSelectFilterKey);
    const hasKey = Object.hasOwn(mergedParams, key);

    if (hasKey && isMultiSelectFltr) {
      mergedParams[key] = stringToArray(mergedParams[key] ?? [])
        .concat(stringToArray(value ?? []))
        .filter((val, i, self) => self.indexOf(val) === i);
    } else if (!hasKey) {
      mergedParams[key] = isArrayOnlyFltr ? stringToArray(value ?? []) : value;
    }
  });

  return mergedParams as FilterParams;
};
